import Button from "@/components/Buttons/Button";
import Modal from "@/components/application/Modal";
import { useState } from "react";
import FormCreateTeam from "@/components/Modal/CreateTeam/FormCreateTeam.tsx";
import { Users } from "lucide-react";
import { useMediaQuery } from "@/integration/application/hooks/useMediaQuery";
import { useNavigate } from "react-router-dom";

export default function ModalCreateTeam() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();

  const handleClick = () => {
    if (isMobile) {
      navigate("/team/create");
    } else {
      setIsOpen(true);
    }
  };

  return (
    <div className="flex-coltext-white">
      <Button
        onClick={handleClick}
        className=" w-full  text-white  text-sm font-medium "
        icon={<Users size={16} />}
        backgroundColor="bg-green-500 text-green-400 font-medium rounded-md"
        borderColor="border border-1 bg-green-400/20 text-green-300"
        hoverColor="hover:bg-green-600/80 hover:text-green-400"
        label="Criar time"
      />

      <Modal
        width="sm:max-w-[650px] max-w-full min-h-[620px]"
        height=" "
        link="/team/create"
        title="Criar Time"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div className=" overflow-auto">
          <FormCreateTeam onClose={() => setIsOpen(false)} />
        </div>
      </Modal>
    </div>
  );
}